export const TOGGLE_USER_AUTH = 'user/TOGGLE/USER_AUTH';
export const FETCH_USERS = 'user/FETCH_USERS';
export const FETCH_USERS_CLIENT_SOCIETIES = 'user/FETCH_USERS_CLIENT_SOCIETIES';
export const FETCH_USER_DATA = 'user/FETCH_USER_DATA';
export const PUSH_USER = 'user/PUSH_USER';
export const FETCH_TYPES = 'user/FETCH_TYPES';
